"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrivingLicenceNotFoundModalWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var reactstrap_1 = require("reactstrap");
var DrivingLicenceStateEnum_1 = require("../../../enums/DrivingLicenceStateEnum");
var journey_model_1 = require("@athena-portal/journey-model");
var DrivingLicenceNotFoundModalWidget = /** @class */ (function (_super) {
    __extends(DrivingLicenceNotFoundModalWidget, _super);
    function DrivingLicenceNotFoundModalWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.MODAL_FIELD_IN_UI_STATE = "uistate.shouldShowDrivingLicenceNotFoundModal";
        _this.DRIVING_LICENCE_VERIFICATION_STATE_IN_UI_STATE = "uistate.drivingLicenceState";
        _this.DRIVING_LICENCE_HANDY = "policyHolder.drivingLicenceHandy";
        _this.isDLNVerificationPage = _this.props.interaction.uistate.isDLNVerificationPage;
        _this.state = {
            isModalOpen: true
        };
        _this.closeModal = _this.closeModal.bind(_this);
        _this.onAcceptClicked = _this.onAcceptClicked.bind(_this);
        _this.onDeclineClicked = _this.onDeclineClicked.bind(_this);
        return _this;
    }
    DrivingLicenceNotFoundModalWidget.prototype.componentDidMount = function () {
        this.validateQuestion = this.getSetting("validateQuestion");
        if (!this.validateQuestion) {
            throw new Error("Setting 'validateQuestion' must be provided!");
        }
        this.declinePage = this.getSetting("declinePage");
        if (!this.declinePage) {
            throw new Error("Setting 'declinePage' must be provided!");
        }
    };
    DrivingLicenceNotFoundModalWidget.prototype.render = function () {
        var closeButton = (0, jsx_runtime_1.jsx)("button", { className: "btn-close", onClick: this.closeModal });
        return ((0, jsx_runtime_1.jsxs)(reactstrap_1.Modal, { className: "info-modal", isOpen: this.state.isModalOpen, children: [(0, jsx_runtime_1.jsx)(reactstrap_1.ModalHeader, { close: closeButton, children: (0, jsx_runtime_1.jsxs)("div", { className: "d-flex", children: [(0, jsx_runtime_1.jsx)("img", { className: "info-icon-selected mr-2", src: "/img/Flow-info-selected.svg", alt: "Info icon" }), (0, jsx_runtime_1.jsx)("div", { children: "We couldn't match your driving licence number" })] }) }), (0, jsx_runtime_1.jsxs)(reactstrap_1.ModalBody, { children: [(0, jsx_runtime_1.jsx)("h4", { className: "margin-bottom-32", children: "The number entered does not match DVLA records." }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("h4", { className: "font-weight-bold", children: "Would you like to check and try again?" }), (0, jsx_runtime_1.jsx)("span", { children: "If you select No, you'll need to enter you licence and conviction details manually." })] })] }), (0, jsx_runtime_1.jsxs)(reactstrap_1.ModalFooter, { children: [(0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-primary btn-next mr-2", onClick: this.onAcceptClicked, children: "Yes" }), (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-back", onClick: this.onDeclineClicked, children: "No" })] })] }));
    };
    DrivingLicenceNotFoundModalWidget.prototype.onAcceptClicked = function () {
        this.props.onStateChange(this.DRIVING_LICENCE_VERIFICATION_STATE_IN_UI_STATE, DrivingLicenceStateEnum_1.DrivingLicenceStateEnum.REENTER_LICENCE);
        this.props.engine.validateQuestion(this.validateQuestion);
        this.closeModal();
    };
    DrivingLicenceNotFoundModalWidget.prototype.onDeclineClicked = function () {
        this.props.onStateChange(this.DRIVING_LICENCE_VERIFICATION_STATE_IN_UI_STATE, DrivingLicenceStateEnum_1.DrivingLicenceStateEnum.MANUAL_INPUT);
        if (this.isDLNVerificationPage) {
            this.props.onStateChange(this.DRIVING_LICENCE_HANDY, false);
        }
        this.resetLicenceType();
        this.closeModal();
        void this.props.engine.navigate(this.declinePage, false);
    };
    DrivingLicenceNotFoundModalWidget.prototype.closeModal = function () {
        this.props.onStateChange(this.MODAL_FIELD_IN_UI_STATE, false);
        this.setState({ isModalOpen: false });
    };
    DrivingLicenceNotFoundModalWidget.prototype.resetLicenceType = function () {
        var additionalDriverIndex = this.getSetting("additionalDriverIndex");
        var licenceTypeField = (additionalDriverIndex !== undefined && additionalDriverIndex !== null)
            ? "additionalDrivers[".concat(additionalDriverIndex, "].licence.type")
            : "policyHolder.licence.type";
        this.props.onStateChange(licenceTypeField, null);
    };
    DrivingLicenceNotFoundModalWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: "declinePage", type: journey_model_1.TypeDescriptions.String },
            { name: "validateQuestion", type: journey_model_1.TypeDescriptions.String },
            { name: "additionalDriverIndex", type: journey_model_1.TypeDescriptions.Number }
        ]),
        __metadata("design:paramtypes", [Object])
    ], DrivingLicenceNotFoundModalWidget);
    return DrivingLicenceNotFoundModalWidget;
}(plugin_journey_1.WidgetBase));
exports.DrivingLicenceNotFoundModalWidget = DrivingLicenceNotFoundModalWidget;
//# sourceMappingURL=DrivingLicenceNotFoundModalWidget.js.map